<template>
    <div v-show="show" class="common-popup-bg">
        <div class="common-popup">
            <h3>参数设置</h3>
            <el-form>
                <table class="common-popup-table">
                    <tr>
                        <td>俱乐部：</td>
                        <td v-text="`${configForm.clubName}(${configForm.clubRandomId})`"></td>
                    </tr>
                    <tr>
                        <td>对赌基金仓：</td>
                        <td>
                          <el-input placeholder="对赌基金"
                              v-model="searchVal">
                          </el-input>
                        </td>
                    </tr>

                    <tr>
                        <td>对赌比例：</td>
                        <td>
                            <el-radio-group v-model="clubRabtio">
                                <el-radio :label="configForm.clubRabtio"><span
                                        v-text="`${configForm.clubRabtio}%`"></span></el-radio>
                                <el-radio :label="profitValClub">自定义
                                  <el-input
                                      size="medium"
                                      type="number"
                                      suffix-icon="icon-percent"
                                      v-model.number="profitValClub"/>
                                </el-radio>
                            </el-radio-group>
                        </td>
                    </tr>

                  <tr>
                    <td>风险比例：</td>
                    <td>
                      <el-radio-group v-model="chipRabtio">
                        <el-radio :label="configForm.chipRabtio"><span
                            v-text="`${configForm.chipRabtio}%`" v-bind="getTribeProfit(configForm.tribeId)"></span></el-radio>
                        <el-radio :label="profitValChip">自定义
                          <el-input
                              size="medium"
                              type="number"
                              suffix-icon="icon-percent"
                              v-model.number="profitValChip"/>
                        </el-radio>
                      </el-radio-group>
                    </td>
                  </tr>
                  <tr>
                    <td>返佣比例：</td>
                    <td>
                      <el-radio-group v-model="clubShareRabio">
                        <el-radio :label="configForm.clubShareRabio"><span
                            v-text="`${configForm.clubShareRabio/100}%`"></span></el-radio>
                        <el-radio :label="profitValShare">自定义
                          <el-input
                              size="medium"
                              type="number"
                              suffix-icon="icon-percent"
                              v-model.number="profitValShare"/>
                        </el-radio>
                      </el-radio-group>
                    </td>
                  </tr>
                  <tr>
                    <td>联盟比例：</td>
                    <td v-text="`${configForm.recordRabtio} %`"></td>
                  </tr>
                    <tr>
                        <td>开启状态：</td>
                        <td style="text-align: left" colspan="2">
                            <el-switch
                                    v-model="isopen"
                                    :active-value="1"
                                    :inactive-value="0"/>
                        </td>
                    </tr>
                </table>
            </el-form>
            <footer>
                <el-button size="small" @click="show = false">取消</el-button>
                <el-button size="small" type="primary" @click="submitConfig">确定</el-button>
            </footer>
        </div>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        props: {
            info: Object
        },
        data() {
            return {
              show: false,
              profitValClub: '',
              profitValChip:'',
              profitValShare:'',
                tribeIdVal: '',
                configForm: {},
              isopen: 0,//
              searchVal:'',
              clubRabtio:'',
              chipRabtio:'',
              clubShareRabio:'',
              recordRabtio:''
            }
        },
        computed: {
            ...mapState('union', ['allUnionList']),
        },
        created() {
            this.getAllUnionList();
        },
        watch: {
            info(newVal){
                if (!newVal) return;
                this.profitValClub = '';
                this.profitValChip = '';
                this.tribeIdVal = '';
                this.profitValShare = '';
                this.configForm = {
                    clubName: newVal.clubName,
                    id: newVal.id,
                    clubRandomId: newVal.clubRandomId,
                    tribeId: newVal.tribeId,
                    chipRabtio:newVal.chipRabtio,
                    clubRabtio:newVal.clubRabtio,
                    nowTribeProfit:this.getTribeProfit(this.configForm.tribeId),
                    clubShareRabio:newVal.clubShareRabio,
                    recordRabtio:newVal.recordRabtio
                }
                this.searchVal = newVal.chip /100;
                this.isopen = newVal.open ? 1 : 0;
                this.clubRabtio = newVal.clubRabtio;
                this.chipRabtio = newVal.chipRabtio;
                this.clubShareRabio = newVal.clubShareRabio/100;
            },
            profitValClub(newVal) {
                if (!newVal) return;
                this.clubRabtio = newVal;
            },
            profitValChip(newVal) {
                if (!newVal) return;
                this.chipRabtio = newVal;
            },
            profitValShare(newVal) {
              if (!newVal) return;
              this.clubShareRabio = newVal;
            }
        },
        methods: {
            ...mapActions('club', ['updateRebateConfig']),
            ...mapActions('union', ['getAllUnionList','getTribeProfitAPI']),
            getTribeProfit(val){
              if (val===undefined) {
                return
              }
              this.getTribeProfitAPI({
                tribeId:val
              }).then(res => {
                 this.configForm.nowTribeProfit=res.data==null?0:res.data;
              }).catch(()=>{
                alert("请求失败")
              })
            },
            //提交修改
            submitConfig: function () {
                const {id, profit, defaultProfit} = {...this.configForm};
                let params = {
                    clubId: id,
                    isopen: this.isopen,
                    searchVal: this.searchVal * 100,
                    clubRabtio: this.clubRabtio,
                    chipRabtio: this.chipRabtio,
                    clubShareRabtio: this.clubShareRabio * 100
                };
                if (profit !== defaultProfit) {
                    params.profit = profit
                }


                 // this.$message.error(id + " "  + this.isopen  +" " +this.searchVal +" " +this.clubRabtio + " " +this.chipRabtio +"  " + this.clubShareRabio);
                this.updateRebateConfig(params).then(() => {
                    this.$emit('my-submit');
                    this.show = false;
                    this.$message.success('修改成功');
                })
            },
        }
    }
</script>